module.exports = __webpack_public_path__ + "static/media/chart3Icon.0f59ed99.svg";